import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'app/components/ui/table';
import { useDashboardSlice } from '../../slice';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from 'app/components/ui/hover-card';
import { File } from 'lucide-react';
import { convertDateFormat } from 'utils/format-date';
export function RecentRequestFiles() {
  const { useGetRecentRequestFile } = useDashboardSlice();
  const [getList, { data: recentUsers, error, isLoading }] =
    useGetRecentRequestFile({});

  useEffect(() => {
    getList();
  }, []);

  return (
    <Card className=" bg-white  border-none  dark:bg-transparent rounded-xl overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3 border-b border-gray-200 bg-[#0E7490] text-white">
        <CardTitle className="text-md font-medium flex items-center gap-2">
          <File className="w-4 h-4 text-white" />
          Recent Request Files
        </CardTitle>
        <Link
          to="/request-files"
          className="text-xs  hover:underline uppercase flex items-center gap-1 text-white"
        >
          View All
        </Link>
      </CardHeader>
      <CardContent className="mt-4 overflow-x-auto max-h-[530px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-500 text-xs uppercase">
                Name
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Purpose
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Created At
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentUsers?.data?.length ? (
              recentUsers.data.map(user => (
                <TableRow key={user.user_id} className="hover:bg-gray-50">
                  <TableCell className="font-medium">{user?.name}</TableCell>
                  <TableCell className="text-gray-700">
                    <HoverCard>
                      <HoverCardTrigger className="max-w-[200px] overflow-hidden whitespace-nowrap block">
                        {user?.purpose}
                      </HoverCardTrigger>
                      <HoverCardContent>{user?.purpose}</HoverCardContent>
                    </HoverCard>
                  </TableCell>
                  <TableCell className="text-gray-500 text-sm">
                    {convertDateFormat(user.created_at)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={4}
                  className="text-center text-gray-400 py-8"
                >
                  No recent users found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
